<app-no-header></app-no-header>

<div class="flex flex-col items-center mt-5">
  <div class="relative w-full flex justify-center">
    <a (click)="navigate('/app/home')">
      <ion-img src="../../../assets/images/Logo FOUNDEK-19.png" class="w-[230px]"></ion-img>
    </a>
    <ion-button fill="clear" mode="ios" class="absolute top-0 right-2 h-fit" size="small"
      (click)="navigateToNotifications()">
      <div class="relative">
        <ion-icon class="text-[22px]" slot="icon-only" src="../../../assets/svg/bell.svg"></ion-icon>
        <!-- Indicador de notificaciones sin leer -->
        <div
          *ngIf="hasUnreadNotifications"
          class="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full"
          aria-label="Tienes notificaciones sin leer"
        ></div>
      </div>
    </ion-button>
  </div>

  <div class="flex max-w-2xl gap-2 w-full px-4 mt-6">
    <ion-button color="success" class="flex-1 h-10 app-shadow" size="small" mode="ios" (click)="setPostToCreate(0)">
      <ion-label class="text-[10px] font-bold text-ellipsis">{{ 'HOME.FOUND_SOMETHING' | translate }}</ion-label>
    </ion-button>
    <ion-button color="danger" class="flex-1 h-10 app-shadow" size="small" mode="ios" (click)="setPostToCreate(1)">
      <ion-label class="text-[10px] font-bold text-ellipsis">{{ 'HOME.LOST_SOMETHING' | translate }}</ion-label>
    </ion-button>
  </div>

  <!-- Título de la sección según el contexto (categorías o subcategorías) -->
  <ng-container *ngIf="!viewingSubcategories">
    <ion-label class="text-lg font-bold text-white my-4 w-full max-w-[450px] px-4">
      {{ 'HOME.WHAT_LOOKING_FOR' | translate }}
    </ion-label>
  </ng-container>

  <!-- Botón para volver a categorías cuando se está viendo subcategorías -->
  <button *ngIf="viewingSubcategories" (click)="showAll()"
    class="w-full max-w-[450px] flex items-center gap-4 px-4 my-4 text-white">
    <ion-icon src="../../../assets/svg/arrowLeft.svg"></ion-icon>
    <ion-label class="text-lg font-bold">{{ selectedCategory?.name }}</ion-label>
  </button>
</div>

<!-- Contenedor principal para las categorías o subcategorías -->
<ion-content class="ion-padding categories-container" scroll-y="true" style="--background: transparent">
  <ion-refresher slot="fixed" (ionRefresh)="refreshCategories($event)" pullFactor="0.8" pullMin="60" pullMax="120">
    <ion-refresher-content pullingText="{{ 'HOME.PULL_TO_REFRESH' | translate }}" refreshingText="{{ 'HOME.REFRESHING' | translate }}">
    </ion-refresher-content>
  </ion-refresher>

  <div class="category-wrapper w-full max-w-[450px] mx-auto">
    <!-- Indicador de carga inicial para categorías -->
    <div *ngIf="!viewingSubcategories && isLoading && items.length === 0" class="flex justify-center w-full my-4">
      <ion-spinner name="circular"></ion-spinner>
    </div>

    <!-- Indicador de carga inicial para subcategorías -->
    <div *ngIf="viewingSubcategories && isLoadingSubcategories && subcategories.length === 0" class="flex justify-center w-full my-4">
      <ion-spinner name="circular"></ion-spinner>
    </div>

    <!-- Lista de categorías (cuando no se están viendo subcategorías) -->
    <div *ngIf="!viewingSubcategories" class="categories-list mb-8" style="padding-bottom: 20px;">
      <!-- Opción "Ver todo" para categorías -->
      <div>
        <app-category class="w-full block category-item view-all-item" [category]="viewAllCategory" (click)="navigateToViewAll()">
        </app-category>
      </div>
      <div *ngFor="let category of items">
        <app-category class="w-full block category-item" [category]="category" (click)="select(category)">
        </app-category>
      </div>
    </div>

    <!-- Lista de subcategorías (cuando se están viendo subcategorías) -->
    <div *ngIf="viewingSubcategories" class="categories-list mb-8" style="padding-bottom: 20px;">
      <!-- Opción "Ver todo" para subcategorías -->
      <div>
        <app-category class="w-full block subcategory-item view-all-item" [category]="viewAllSubcategory" (click)="navigateToViewAllInCategory()">
        </app-category>
      </div>
      <div *ngFor="let subcategory of subcategories">
        <app-category class="w-full block subcategory-item" [category]="subcategory" (click)="select(subcategory)">
        </app-category>
      </div>
    </div>

    <!-- Mensaje cuando no hay categorías y no está cargando -->
    <div *ngIf="!viewingSubcategories && !isLoading && items.length === 0" class="text-white text-center w-full py-4">
      {{ 'HOME.NO_CATEGORIES' | translate }}
    </div>

    <!-- Mensaje cuando no hay subcategorías y no está cargando -->
    <div *ngIf="viewingSubcategories && !isLoadingSubcategories && subcategories.length === 0" class="text-white text-center w-full py-4">
      {{ 'HOME.NO_SUBCATEGORIES' | translate }}
    </div>
    <!-- Infinite Scroll con ID y más propiedades de configuración para un mejor manejo -->
    <ion-infinite-scroll #infiniteScroll id="categoryInfiniteScroll" threshold="100px" position="bottom"
      (ionInfinite)="loadMoreCategories($event)" [disabled]="viewingSubcategories ? loadedAllSubcategories : loadedAllCategories">
      <ion-infinite-scroll-content
        loadingText="{{ viewingSubcategories ? 'HOME.LOADING_MORE_SUBCATEGORIES' : 'HOME.LOADING_MORE_CATEGORIES' | translate }}"
        loadingSpinner="bubbles">
      </ion-infinite-scroll-content>
    </ion-infinite-scroll>
  <!-- Spacer para asegurar que el último elemento no quede oculto tras la tab bar en iOS -->
  <div class="bottom-safe-spacer"></div>
  </div>
</ion-content>

<app-dialog [show]="show" type="accept" (toggle)="show = false" (confirm)="confirm()" [close]="true">
  <ion-label class="text-[13px] mt-4 text-[#131C4F]" [innerHTML]="'AUTH.SIGN_IN_NOTICE' | translate">
  </ion-label>
</app-dialog>
